import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a0d] py-16 px-4" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="text-center mb-10" data-id="element-75">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-76">
            🕊️ ¿QUÉ AGREGA EL KIT ADAPTACIONES{' '}
            <span className="text-[#00C853]" data-id="element-77">
              &quot;ITALIANO SIN BARRERAS&quot;
            </span>
            ?
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00C853]/30 rounded-2xl overflow-hidden mb-12" data-id="element-78">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d08] border-b border-[#00C853]/30" data-id="element-79">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-80">
              Situación en el aula
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00C853]/30" data-id="element-81">
              ❌ Sin Kit
            </div>
            <div className="p-4 font-bold text-[#00C853] text-center border-l border-[#00C853]/30" data-id="element-82">
              ✅ Con Kit
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-83">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-84">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-85">
                Situación:
              </span>
              Alumno que no puede hacer la actividad estándar
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-87">
                ❌ Sin Kit:
              </span>
              Improvisás en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-88">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-89">
                ✅ Con Kit:
              </span>
              Versione BASIC lista. 30 segundos.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-90">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-91">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-92">
                Situación:
              </span>
              Necesitan examen diferenciado el día de la verifica
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-94">
                ❌ Sin Kit:
              </span>
              Lo armás el domingo a la noche
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-95">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-96">
                ✅ Con Kit:
              </span>
              Valutazione Differenziata. Ya está.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-97">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-98">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-99">
                Situación:
              </span>
              Dirección pide ver el registro de adecuaciones
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-101">
                ❌ Sin Kit:
              </span>
              Buscás algo que no encontrás
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-102">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-103">
                ✅ Con Kit:
              </span>
              Plantilla firmada. Profesional.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-104">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-105">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-106">
                Situación:
              </span>
              Alumno con dislexia no puede leer el material
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-108">
                ❌ Sin Kit:
              </span>
              Dictás o simplificás
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-109">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-110">
                ✅ Con Kit:
              </span>
              Ficha Lettura Facile. Ya está hecha.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-111">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-112">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-113">
                Situación:
              </span>
              Distintos niveles juntos en el mismo grupo
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-115">
                ❌ Sin Kit:
              </span>
              Perdés a todos
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-116">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-117">
                ✅ Con Kit:
              </span>
              Protocollo Aula Aperta. Todos trabajan.
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-118">
          ✅ EL KIT INCLUYE:
        </h3>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-119">
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-120">
            Sistema Contenuto Specchio (3 versiones de cada unidad)
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-121">
            Lettura Facile
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-122">
            Fichas pictográficas
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-123">
            Valutazione Differenziata
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-124">
            Guida DSA/BES
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-125">
            Protocollo Aula Aperta
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-126">
            Banco Slow-Track
          </span>
          <span className="bg-black border border-[#00C853]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-127">
            Pittogrammi d'Aula
          </span>
        </div>
      </div>
    </section>;
}